import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@/components/ui/inputs/Checkbox/Checkbox";

import type { DropdownProps, MultiDropdownProps } from "./Dropdown";

type Props<TKey extends Key = Key> = Pick<MultiDropdownProps<TKey>, "onChange" | "value"> &
  Pick<DropdownProps<TKey>, "items">;

export const DropdownListBoxAllOption = <TKey extends Key = Key>({ onChange, value, items }: Props<TKey>) => {
  const { t } = useTranslation();

  return (
    <div className="border-elevation-outline-1 border-b bg-elevation-background px-4 py-2">
      <Checkbox
        onChange={(isChecked) => {
          if (isChecked) {
            onChange(items.map((item) => item.id));
            return;
          }

          onChange([]);
        }}
        isSelected={value.length === items.length}
        isIndeterminate={value.length > 0 && value.length < items.length}
      >
        {t("ui.dropdown.allOption")}
      </Checkbox>
    </div>
  );
};
